import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';


const CTASection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-24 px-4 md:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="relative bg-gradient-to-br from-card to-card/50 border border-border rounded-2xl p-8 md:p-10 lg:p-12 overflow-hidden">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-[0.02]">
            <div className="absolute inset-0" style={{
              backgroundImage: `linear-gradient(var(--color-primary) 1px, transparent 1px),
                               linear-gradient(90deg, var(--color-primary) 1px, transparent 1px)`,
              backgroundSize: '32px 32px'
            }} />
          </div>

          {/* Content */}
          <div className="relative z-10 text-center">
            {/* Heading */}
            <h2 className="text-2xl font-bold text-foreground mb-3 md:mb-4 lg:mb-5">
              See Sleeve in Action
            </h2>

            {/* Description */}
            <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
              Schedule a live demo to see how Sleeve orchestrates agents, systems, and people across your infrastructure.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-5">
              <Button
                variant="default"
                size="lg"
                iconName="Video"
                iconPosition="left"
                className="w-full sm:w-auto"
                onClick={() => navigate('/contact')}
              >
                Request a Live Platform Demo
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="FileText"
                iconPosition="left"
                className="w-full sm:w-auto"
              >
                Explore Technical Details
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;